import { useState } from 'react';
import { SectionHeader } from 'components';
import CasaSelectListTile from 'components/Casa/Components/CasaSelectListTile';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import styles from '../child.module.css';

export default function ChildResourceParents(rps) {
	const [expanded, setExpanded] = useState(false);

	const handleOpenClose = () => {
		setExpanded(!expanded);
	};

	const tileMapper = (val, index) => {
		if (!val) {
			return null;
		}

		return (
			<div key={`${val.id}${index}`}>
				<CasaSelectListTile
					selectable={false}
					value={`Name: ${val.firstname} ${val.lastname}`}>
					{`${val.firstname} ${val.lastname}`}
				</CasaSelectListTile>
			</div>
		);
	};

	const tileMap = rps?.parents?.map(tileMapper);

	return (
		<>
			{rps?.parents?.length > 0 ? (
				<div className={styles.childCswRoot}>
					<SectionHeader>
						<div className={styles.basicHeader}>
							<div className={styles.headerText}>PARENTS</div>
							{expanded ? (
								<ExpandLess onClick={() => handleOpenClose()} />
							) : (
								<ExpandMore onClick={() => handleOpenClose()} />
							)}
						</div>
					</SectionHeader>
					{expanded && (
						<div className={styles.selectorListTileList}>{tileMap}</div>
					)}
				</div>
			) : null}
		</>
	);
}
